import { render } from "./CrudCarreta.vue?vue&type=template&id=d528b0f8"
import script from "./CrudCarreta.vue?vue&type=script&lang=ts"
export * from "./CrudCarreta.vue?vue&type=script&lang=ts"
script.render = render

export default script